import ReactDOM from 'react-dom/client'
import { useEffect } from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/browser'
import App from '@/app'
import { SENTRY_SDN_URL } from './constants/sentry'
import 'react-resizable/css/styles.css'
import '@bty/chat-ui/dist/index.css'
import 'virtual:uno.css'
import './styles/index.css'
import { DataTrack } from './features/track'
import { trackList } from './track.config'
import ignoreError from './utils/sentry'
import { isPrivateVersion } from './constants/common'

const isLocal = process.env.NODE_ENV === 'local'

if (!isLocal && !isPrivateVersion) {
  Sentry.init({
    dsn: SENTRY_SDN_URL,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV6Instrumentation(
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        ),
      }),
    ],
    environment: __DEFINE_ENV__,
    release: __DEFINE_RELEASE_VERSION__,
    tracesSampleRate: 1.0,
    beforeSend(event, hint) {
      if (ignoreError(hint?.originalException)) return null
      return event
    },
  })
}

DataTrack.init({ trackList })

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <App />,
)
